var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-8 mx-auto mt-3 mb-5"},[_c('div',{staticClass:"steps"},[_c('button',{staticClass:"steps-btn",class:{
                    'highlighted': true,
                    'enabled': true,
                    'current': _vm.current == 'log'
                },on:{"click":_vm.openLog}},[_c('span',[_vm._v(_vm._s(_vm.$t('common.log')))])]),_vm._v(" "),_c('button',{staticClass:"steps-btn notfirst",class:{
                    'highlighted': true,
                    'enabled': true,
                    'current': _vm.current == 'summary',
                },on:{"click":_vm.openSummary}},[_c('span',[_vm._v(_vm._s(_vm.$t('sessions.summary')))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }